import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { RefundReasons, OverlayForm } from '../../../models';

@Component({
  selector: 'app-refund-form',
  templateUrl: './refund-form.component.html',
  styleUrls: ['./refund-form.component.css']
})
export class RefundFormComponent extends OverlayForm implements OnInit {

  @Input() fullAmount = 0;
  form: FormGroup;
  reasons = RefundReasons;

  constructor(
    public fb: FormBuilder
  ) {
    super(fb);
  }

  ngOnInit() {
    this.form.controls.amount.valueChanges.subscribe(
      amount => amount > this.fullAmount && this.form.controls.amount.patchValue(this.fullAmount)
    );
  }

  buildForm() {
    this.form = this.fb.group({
      amount: [null, [Validators.required, (c: AbstractControl) => c.value <= this.fullAmount]],
      reason: [null, Validators.required],
      notes: null,
      addBalance: null
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/refund-form/refund-form.component.ts